<template>
<section>
    <div class="nav-box">
        <ul>
            <li @click="toHome">
                <div class="icon">
                    <img src="../assets/images/nav-home.png" alt="">
                </div>
                <div class="nav" style="color: #F36E16">
                    首页
                </div>
            </li>
            <li @click="toThirdSite(1)">
                <div class="icon">
                    <img src="../assets/images/nav-person.png" alt="">
                </div>
                <div class="nav">
                    个人中心
                </div>
            </li>
            <li @click="toThirdSite(2)">
                <div class="icon">
                    <img src="../assets/images/nav-page.png" alt="">
                </div>
                <div class="nav">
                    页游
                </div>
            </li>
            <li @click="toThirdSite(3)">
                <div class="icon">
                    <img src="../assets/images/nav-handgame.png" alt="">
                </div>
                <div class="nav none-border">
                    手游
                </div>
            </li>
        </ul>
    </div>
    <div class="cover" @click="$emit('input', false)"></div>
</section>
    
</template>

<script>
    export default {
        data() {
            return {
                mapTo: new Map([
                    [1, 'http://i.360.cn/index/wap'],
                    [2, 'http://wan.360.cn'],
                    // [3, 'http://youxi.com'],
                    [3, 'http://u.360.cn'],
                    // [5, '/']
                ])
            }
        },
        methods: {
            toThirdSite(num) {
                this.$emit('input', false);
                let url = this.mapTo.get(num);
                if (window) {
                    window.open(url, '_self');
                } else {
                    location.href = url;
                }
            },
            toHome() {
                this.$router.push('/');
                this.$emit('input', false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav-box {
        width:238px;
        position: absolute;
        top: 80px;
        left: 20px;
        // height:664px;
        // background: white;
        z-index: 200;
        background: url('../assets/images/navBg.png') no-repeat;
        background-size: 100% 100%;
        z-index: 200;
        // box-shadow:0px 4px 10px 0px rgba(0,0,0,0.31);
        ul {
            li {
                display: flex;
                align-items: center;
                .icon {
                    width: 62px;
                    height: 32px;
                    padding-left: 22px;
                    box-sizing: border-box;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                    
                }
                .nav {
                    width: 152px;
                    border-bottom: 2px solid #e9e9e9;
                    padding: 66px 0;
                    padding-left: 8px;
                    box-sizing: border-box;
                }
                .nav.none-border {
                    border: none;
                }
            }
        }
    }
    .cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  opacity: 0.4;
  z-index: 100;
}
</style>